import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.7346 2.83483C16.0308 2.13104 14.9166 2.05186 14.1204 2.64904L11.2069 4.83412C9.99675 5.74177 8.57729 6.32973 7.07974 6.54367L4.90344 6.85457C4.17307 6.95891 3.63785 7.74525 3.99024 8.51542C4.32124 9.23882 5.37514 11.1444 8.34987 14.2358L4.1718 18.4139C3.78127 18.8044 3.78127 19.4376 4.1718 19.8281C4.56232 20.2186 5.19549 20.2186 5.58601 19.8281L9.76409 15.65C12.8554 18.6247 14.7609 19.6786 15.4843 20.0096C16.2545 20.362 17.0408 19.8267 17.1452 19.0964L17.4561 16.9201C17.67 15.4225 18.258 14.0031 19.1656 12.7929L21.3507 9.87935C21.9479 9.08311 21.8687 7.96892 21.1649 7.26514L16.7346 2.83483ZM15.3204 4.24904L19.7507 8.67935L17.5656 11.5929C16.4563 13.072 15.7376 14.8069 15.4762 16.6372L15.3332 17.6381C14.3535 17.0134 12.7301 15.8009 10.4645 13.5353C8.19886 11.2697 6.98637 9.64627 6.36169 8.66655L7.36259 8.52357C9.19292 8.26209 10.9278 7.54348 12.4069 6.43412L15.3204 4.24904Z"
	})
});
export default SvgPinLine;
